//import React from 'react';
import React, { Component } from 'react';


class DropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false
        };
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu() {
        this.setState({ menu: !this.state.menu })
    }

    render() {
        const show = (this.state.menu) ? "show" : "";
        return (
            <nav className="navbar-toggler navbar-toggler-right">
                <a className="navbar-brand" href="/">Menu</a>
                <button className="navbar-toggler" type="button" onClick={this.toggleMenu}>

                    <i className="fa fa-bars"></i>
                </button>
                <div className={"collapse navbar-collapse " + show}>
                    <div className="navbar-nav">
                        <a className="nav-item nav-link active" href="#">Home <span class="sr-only">(current)</span></a>
                        <a className="nav-item nav-link" href="#about">About</a>
                        <a className="nav-item nav-link" href="#portfolio">Portifolio</a>
                        <a className="nav-item nav-link" href="#services">Services</a>
                        <a className="nav-item nav-link" href="#team">Team</a>
                        <a className="nav-item nav-link" href="#contact">Contact</a>
                    </div>
                </div>
            </nav>

        );

    }
}

export default DropDown;